<template>
	<div>
		<bsh-datatable 
			:columns="columns"
            :buttons="buttons" 
			:link="$url+'/api/adm/receita/datatable/'+date"
            actionFild
            @selectRow="show"
            @show="show"
            @update="update"
            @destroy="destroy"
			sorting>
		</bsh-datatable>
	</div>
</template>

<script>
export default {
    props: ['date'],
	data(){
		return {
            searchDate: '',
            columns: [
                {
                    label: '#',
                    field: 'id',
                    sort: 'asc'
                },
                {
                    label: 'Pedido',
                    field: 'pedido',
                    order: 'pedidos.id',
                    sort: 'asc'
                },
                {
                    label: 'Cliente',
                    field: 'cliente',
                    order: 'clientes.nome',
                    sort: 'asc'
                },
                {
                    label: 'Data Pagamento',
                    field: 'data_br',
                    order: 'receita.data',
                    noSorting: true
                },
                {
                    label: 'Forma de Pagamento',
                    field: 'forma_pagamento',
                    order: 'receita.forma_pagamento',
                    noSorting: true
                },
                {
                    label: 'Valor',
                    field: 'valor_br',
                    order: 'receita.valor',
                    sort: 'asc'
                }
            ],
            buttons: [
                {
                    action: 'show',
                    classe: 'btn btn-primary',
                    iconClass: 'fas fa-eye'
                },
                {
                    action: 'update',
                    classe: 'btn btn-primary',
                    iconClass: 'fas fa-edit'
                },
                {
                    action: 'destroy',
                    classe: 'btn btn-danger',
                    iconClass: 'fas fa-trash'
                },
            ]
    	}
	},
    methods: {
        show(dado){
            this.$emit('show', dado.pedido);
        },
        update(dado){
            this.$emit('update', dado.id);
        },
        destroy(dado){
            this.$emit('destroy', dado.id);
        }
    }
}
</script>